<div class="wrapper border rounded-[5px] p-[15px]">
  @if (data?.inspection_detail?.id) {
    <div class="row w-full flex flex-row mb-[20px]">
      <div class="sub-row w-1/2 flex flex-col">
        <div class="fieldLabel">
          Arrival time:
        </div>
        <div class="value">
          {{ data?.inspection_detail?.arrival_time | dateFormat:'time' }}
        </div>
      </div>
      <div class="sub-row w-1/2 flex flex-col">
        <div class="fieldLabel">
          Departure time:
        </div>
        <div class="value">
          {{ data?.inspection_detail?.departure_time | dateFormat:'time' }}
        </div>
      </div>
    </div>
    <div class="row flex flex-col mb-[20px]">
      <div class="fieldLabel">
        Break Duration (Minutes):
      </div>
      <div class="value">
        {{ breakDuration }}
      </div>
    </div>
    @if (data?.inspection_detail?.comment) {
      <div class="row flex flex-col mb-[20px]">
        <div class="fieldLabel">
          Note:
        </div>
        <div class="value">
          {{ data?.inspection_detail?.comment }}
        </div>
      </div>
    }
    @if (mediaFiles?.length) {
      <app-pictures-section
        [isEditable]="false"
        [pictures]="mediaFiles"
        class="pictures-section mb-[40px]"
        />
    }
  } @else {
    <app-multiple-time-select
      (checkForErrors)="checkForErrors($event)"
      [error]="errorMessages['time']"
      [fromTimeLabel]="'Arrival Time'"
      [parentFormGroup]="form"
      [toTimeLabel]="'Departure Time'"
      class="w-full mb-[20px]"
      controlName="time"
      label="time"
      />
    <app-number-input
      (checkForErrors)="checkForErrors($event)"
      [controlName]="'break'"
      [error]="errorMessages['break']"
      [label]="'Break Duration (Minutes)'"
      [parentFormGroup]="form"
      class="mb-[20px]"
      />
    <app-text-area
      (checkForErrors)="checkForErrors($event)"
      [controlName]="'comment'"
      [error]="errorMessages['comment']"
      [label]="'Note'"
      [parentFormGroup]="form"
      class="mb-[20px]"
      />
    <app-pictures-section
      (onDelete)="deletePicture($event)"
      [add]="true"
      [pictures]="mediaFiles"
      class="pictures-section mb-[40px]"
      />
    <div class="action-section mb-[20px]">
      <app-secondary-button
        (handleClick)="save()"
        [isDisabled]="form.invalid"
        >
        Save
      </app-secondary-button>
    </div>
  }
</div>
